module.exports = __webpack_public_path__ + "static/media/connectMilesBanner.cc9fbcf2.png";